<template>
  <div class="PageBox">
    <div class="ScrollBox Wallet">
      <van-field
        v-model="selectBank"
        type="text"
        :label="$t('wallet.label[7]')"
        :placeholder="$t('wallet.placeholder[7]')"
        size="large"
        readonly
        @click="showPicker = true"
      />

      <!-- <van-field v-model.trim="drawData.draw_money" type="number" :placeholder="$t('wallet.placeholder[1]')" clearable size="large">
        </van-field> -->
      <div style="margin: 20px 10px 0 10px; background-color: white; padding: 10px">
        <h2 style="color: #000; padding-left: 16px">{{ $t("recharge.label[0]") }}</h2>
        <van-field
          v-model.trim="postData.money"
          type="number"
          :placeholder="$t('recharge.placeholder[0]')"
          style="text-align: left"
        />
      </div>

      <div style="padding: 0 10px; padding-top: 60px">
        <van-button
          round
          type="default"
          block
          style="background-color: #ff5656; font-size: 18px"
          :loading="isSubmit"
          :loading-text="$t('recharge.default[5]')"
          @click="onSubmit"
          >{{ $t("recharge.default[6]") }}</van-button
        >
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="rechargeList"
        @confirm="onConfirm"
        :value-key="'name'"
        @cancel="showPicker = false"
        :confirm-button-text="$t('bankCard.placeholder[3]')"
        :cancel-button-text="$t('bankCard.placeholder[4]')"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Recharge",
  components: {},
  props: ["rechargeId"],
  data() {
    return {
      amountMoney: this.$route.query.amount || "",
      postData: {
        money: this.$route.query.amount || "",
        recharge_id: "",
        name: "",
      },
      rechargeList: "",
      pickerList: "",
      showPicker: false,
      isSubmit: false,
      rechargeData: "",
      rechargeInfo: "",
      showPrice: false,
      pickerName: "",
      jumpData: {
        result: {
          bid: "",
        },
      },
      isLoad: true,
      fileList: [],
      upiData: {
        pay_name: "",
        pay_mobile: "",
        pay_account: "",
        pay_email: "",
      },
      selectBank: "",
    };
  },
  computed: {},
  watch: {
    $route() {
      if (this.rechargeId) {
        this.$parent.navBarTitle = this.$t("recharge.default[1]");
        this.getRechargeInfo();
      } else {
        this.$parent.navBarTitle = this.$t("recharge.default[0]");
        this.$Model.GetRechargeType((data) => {
          this.isLoad = false;
          this.rechargeList = data.info;
        });
      }
    },
  },
  created() {
    console.log(this.$parent);
    if (this.rechargeId) {
      this.$parent.navBarTitle = this.$t("recharge.default[1]");
      this.getRechargeInfo();
    } else {
      this.$parent.navBarTitle = this.$t("recharge.default[0]");
      this.$Model.GetRechargeType((data) => {
        this.isLoad = false;
        this.rechargeList = data.info;
      });
    }
  },
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    selectType(typeid) {
      this.postData = {
        money: this.$route.query.amount || "",
        recharge_id: typeid,
        name: "",
      };
      this.jumpData = {
        result: {
          bid: "",
        },
      };
      this.rechargeInfo = this.rechargeList.find((item) => item.id == typeid);
      console.log(this.rechargeInfo);
      this.showPrice = true;
      if (this.rechargeInfo.bankList) {
        this.pickerList = this.rechargeInfo.bankList;
      } else {
        this.pickerList = "";
      }
      switch (this.rechargeInfo.mode) {
        case "wap":
        case "scan":
          this.jumpData.url = this.rechargeInfo.submitUrl;
          this.jumpData.result = {
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: "",
            scanType: "",
          };
          break;
        case "online":
        case "quick":
          this.jumpData.url = this.rechargeInfo.submitUrl;
          this.jumpData.result = {
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: "",
            bank_code: "",
          };
          break;
        case "upi":
          this.jumpData.url = this.rechargeInfo.submitUrl;
          this.jumpData.result = {
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: "",
            bank_code: "",
            pay_name: "",
            pay_mobile: "",
            pay_account: "",
            pay_email: "",
          };
          break;
      }
    },
    onConfirm(val) {
      switch (this.rechargeInfo.mode) {
        case "wap":
        case "scan":
          this.jumpData.result.scanType = this.rechargeInfo.bankList.find(
            (item) => item.id == val
          ).bank_code;
          break;
        case "online":
        case "quick":
        case "upi":
          this.jumpData.result.bank_code = this.rechargeInfo.bankList.find(
            (item) => item.id == val
          ).bank_code;
          break;
        case "upi":
          this.jumpData.result.bank_code = this.rechargeInfo.bankList.find(
            (item) => item.id == val
          ).bank_code;
          break;
      }
    },
    onSubmit() {
      console.log(this.rechargeInfo.id);
      if (!this.postData.money) {
        this.$Dialog.Alert(this.$t("recharge.placeholder[0]"));
        return;
      }
      if (Number(this.postData.money) < Number(this.rechargeInfo.minPrice)) {
        this.$Dialog.Alert(
          this.$t("recharge.placeholder[3]", {
            currency: this.InitData.currency,
            min: this.rechargeInfo.minPrice,
          })
        );
        return;
      }
      if (Number(this.postData.money) > Number(this.rechargeInfo.maxPrice)) {
        this.$Dialog.Alert(
          this.$t("recharge.placeholder[4]", {
            currency: this.InitData.currency,
            max: this.rechargeInfo.maxPrice,
          })
        );
        return;
      }
      if (this.rechargeInfo.id == 129) {
        if (!this.postData.name) {
          this.$Dialog.Alert(this.$t("recharge.placeholder[6]"));
          return;
        }
      }

      switch (this.rechargeInfo.mode) {
        case "wap":
        case "scan":
        case "online":
        case "quick":
        case "upi":
          if (!this.jumpData.result.bid) {
            this.$Dialog.Alert(this.$t("recharge.placeholder[1]"));
            return;
          }
          if (this.rechargeInfo.mode == "upi") {
            // if (!this.upiData.pay_name) {
            //   this.$Dialog.Toast(this.$t("recharge.placeholder[5]"));
            //   return;
            // }
            // if (!this.upiData.pay_mobile) {
            //   this.$Dialog.Toast(this.$t("recharge.placeholder[6]"));
            //   return;
            // }
            if (!this.upiData.pay_account) {
              this.$Dialog.Toast(this.$t("recharge.placeholder[7]"));
              return;
            }
            // if (!this.upiData.pay_email) {
            //   this.$Dialog.Toast(this.$t("recharge.placeholder[8]"));
            //   return;
            // }

            // this.jumpData.result.pay_name = this.upiData.pay_name;
            // this.jumpData.result.pay_mobile = this.upiData.pay_mobile;
            this.jumpData.result.pay_account = this.upiData.pay_account;
            // this.jumpData.result.pay_email = this.upiData.pay_email;
          }

          this.jumpData.result.name = this.postData.name;
          this.jumpData.result.price = this.postData.money;
          const url = this.jumpData.url + "?" + $.param(this.jumpData.result);
          this.$Util.OpenUrl(url);
          break;
        default:
          // if (!this.postData.name) {
          //   this.$Dialog.Alert(this.$t("recharge.placeholder[2]"));
          //   return;
          // }
          if (!this.fileList.length) {
            this.$Dialog.Alert(this.$t("recharge.placeholder[9]"));
            return;
          }
          this.postData.pic_url = this.fileList.flatMap((item) => item.url);
          this.isSubmit = true;
          this.$Model.RechargeOrder(this.postData, (data) => {
            this.isSubmit = false;
            if (data.code == 1) {
              this.showPrice = false;
              this.rechargeData = data;
            }
          });
      }
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = this.$t("upload[0]");
      this.uploadImgs(file);
    },
    compressImg(file) {
      this.$Util.CompressImg(file.file.type, file.content, 750, (image) => {
        let param = new FormData();
        param.append("token", localStorage["Token"]);
        param.append("type", 4);
        param.append("image", image, file.file.name);
        this.$Model.UploadImg(param, (data) => {
          if (data.code == 1) {
            file.message = this.$t("upload[2]");
            file.status = "success";
            file.url = data.url;
          } else {
            file.status = "failed";
            file.message = this.$t("upload[3]");
          }
        });
      });
    },
    uploadImgs(file) {
      if (file.length) {
        file.forEach((item) => {
          if (!item.file.type.match(/image/)) {
            item.status = "failed";
            item.message = this.$t("upload[1]");
            return;
          }
          this.compressImg(item);
        });
      } else {
        if (!file.file.type.match(/image/)) {
          file.status = "failed";
          file.message = this.$t("upload[1]");
          return;
        }
        this.compressImg(file);
      }
    },
    setOrderInfo() {
      const screenshots = this.fileList.flatMap((item) =>
        item.url.replace(this.InitData.setting.up_url, "")
      );
      this.$Model.SetOrderInfo(
        { orderNumber: this.rechargeId, screenshots: screenshots },
        (data) => {
          this.getRechargeInfo();
        }
      );
    },
    getRechargeInfo() {
      this.$Model.GetRechargeInfo(this.rechargeId, (data) => {
        this.isLoad = false;
        this.rechargeData = data;
        this.fileList = data.screenshots
          ? data.screenshots.flatMap((item) => [
              { url: this.InitData.setting.up_url + item },
            ])
          : [];
      });
    },
    onConfirm(val) {
      this.selectBank = val.name;
      this.showPicker = false;
    },
  },
};
</script>
<style scoped>
.PageBox .van-cell >>> .van-field__label {
  width: 3.625rem;
  margin-right: 0px;
}
.PageBox .van-cell >>> .van-field__control {
  text-align: left;
}
.RechargeList {
  margin-bottom: 20px;
}
.RechargeList .van-cell__title {
  line-height: 1;
}
.RechargeInfo .van-cell >>> .van-field__control {
  text-align: right;
}
.RechargeInfo .van-cell--large >>> .van-field__control {
  font-size: 16px;
}
.RechargeInfo .van-cell .van-cell__value em {
  font-size: 20px;
  color: #4087f1;
}
.RechargeInfo .van-panel {
  margin: 10px;
  border: 1px rgba(255, 255, 255, 0.2) solid;
  border-radius: 3px;
  background-color: #151d31;
}
.RechargeInfo .van-panel__header {
  background-color: #242d41;
  color: #fff;
}
.RechargeInfo .van-panel__content .van-cell {
  padding: 0 16px;
  margin: 10px 0;
}
.RechargeInfo .van-panel__content >>> .van-field__control {
  text-align: left;
}
.RechargeInfo .van-panel__content img {
  width: 80%;
  margin: 0 auto;
  display: block;
}
.van-divider {
  font-size: 12px;
  line-height: 1.5;
}
.MoneyList {
  word-break: break-word;
}
.MoneyList .van-cell__value {
  flex: auto;
}
.MoneyList .van-radio--horizontal {
  margin: 3px 6px 3px 0;
  position: relative;
}
.MoneyList .van-radio-group >>> .van-radio__icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.MoneyList .van-radio-group >>> .van-radio__icon--checked ~ .van-radio__label {
  padding: 0 17px 0 3px;
}
.MoneyList .van-radio-group >>> .van-radio__icon .van-icon {
  width: 100%;
  border-radius: 5px;
  text-align: right;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.MoneyList .van-radio-group >>> .van-radio__label {
  margin: 0;
  position: relative;
  z-index: 9;
  padding: 0 10px;
  line-height: 28px;
  color: #fff;
}
.van-uploader >>> .van-uploader__upload,
.van-uploader >>> .van-uploader__preview-image {
  width: 60px;
  height: 60px;
}
.van-uploader >>> .van-uploader__upload,
.van-uploader >>> .van-uploader__preview {
  margin: 4px 8px 4px 0;
  background-color: #f7f8fa;
  border-radius: 8px;
}
.zhpz {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: 13px 0;
}
.zhpz label {
  color: #333;
  position: relative;
  display: flex;
  box-sizing: border-box;
  padding: 10px 16px;
  overflow: hidden;
  font-size: 14px;
}
.vod_msg {
  margin: 0 15px;
}
.vod_msg span {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding: 10px;
  border: 1px #999 solid;
}
.ScrollBox {
  background-color: #f4f5f7;
}
/deep/.PageBox .van-cell .van-field__control {
  text-align: left;
}
</style>
